// extracted by mini-css-extract-plugin
export default {"input":"regular-input_input__XUqSl"};